// Sons de notification générés via Web Audio API — pas de fichier .mp3 nécessaire.
const SOUND_CONFIGS = {
  nouvelle_reservation: { frequency: 880, duration: 0.3, type: 'sine' },
  paiement_recu: { frequency: 1046, duration: 0.5, type: 'sine' },
  reservation_annulee: { frequency: 440, duration: 0.4, type: 'sawtooth' },
  impaye_alerte: { frequency: 330, duration: 0.6, type: 'square' },
  checkin_today: { frequency: 660, duration: 0.35, type: 'triangle' },
};

export function jouerSonNotification(type) {
  try {
    const config = SOUND_CONFIGS[type] || SOUND_CONFIGS.nouvelle_reservation;
    const Ctx = window.AudioContext || window.webkitAudioContext;
    const ctx = new Ctx();
    const oscillator = ctx.createOscillator();
    const gainNode = ctx.createGain();

    oscillator.connect(gainNode);
    gainNode.connect(ctx.destination);

    oscillator.frequency.value = config.frequency;
    oscillator.type = config.type;
    gainNode.gain.setValueAtTime(0.3, ctx.currentTime);
    gainNode.gain.exponentialRampToValueAtTime(0.01, ctx.currentTime + config.duration);

    oscillator.start(ctx.currentTime);
    oscillator.stop(ctx.currentTime + config.duration);
    oscillator.onended = () => ctx.close();
  } catch (err) {
    console.log('Son notification bloqué:', err);
  }
}
